import * as React from 'react';
import RangeComponent from './RangeComponent'
import ExclusionComponent from './ExclusionComponent'
import DeleteConfirmationModalComponent from './DeleteConfirmationModalComponent'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus'
import { faMinus } from '@fortawesome/free-solid-svg-icons/faMinus'
import { CPVariable } from '../models/CPVariable';
import { useState } from 'react';
const cloneDeep = require('lodash.clonedeep');

export interface VariableComponenetProps {
    variables: Array<CPVariable>,
    setVariables: Function,
    userIsOwner: boolean,
    limitedEditing: boolean,
}

const VariableComponent = (props: VariableComponenetProps) => {

    const [selectedVariableId, setSelectedVariableId] = useState<number | undefined>()
    const [selectedDependentVariableId, setSelectedDependentVariableId] = useState<number | undefined>()
    const [previousValue, setPreviousValue] = useState<string | undefined>()

    const removeInvalidCharactersFromVariableName = (name: string) => {
        name = name.replace('[', '')
        name = name.replace(']', '')
        name = name.replace('.', '')
        return name
    }

    const variableNameChange = input => {
        let updatedVariables = cloneDeep(props.variables)
        updatedVariables[input.dataset.index].name = removeInvalidCharactersFromVariableName(input.value)
        props.setVariables(updatedVariables)
    }

    const dependentVariableCalculationChange = (value, index) => {
        let updatedVariables = cloneDeep(props.variables)
        updatedVariables[index].calculation = value
        props.setVariables(updatedVariables)
    }

    const dependentVariablePrecisionChange = (value, index) => {
        let updatedVariables = cloneDeep(props.variables)
        value = Math.abs(parseInt(value))
        if (isNaN(value)) {
            value = ""
        }
        updatedVariables[index].precision = value
        props.setVariables(updatedVariables)
    }

    const variableNameFocus = input => {
        setPreviousValue(input.value)
    }

    const variableNameBlur = input => {
        if (input.value == "") {
            input.value = previousValue
            variableNameChange(input)
            return true
        }
        if (input.value == "g") {
            input.value = previousValue
            variableNameChange(input)
            return true
        }
        if (input.value.includes("[") || input.value.includes("]")) {
            input.value = previousValue
            variableNameChange(input)
            return true
        }
        var variablesWithSameNameCount = 0
        props.variables.forEach(variable => {
            if (input.value == variable.name) {
                variablesWithSameNameCount++
            }
        })
        // There will always be one variable with the same name because you just set one of the names to the input value
        if (variablesWithSameNameCount > 1) {
            input.value = previousValue
            variableNameChange(input)
            return true
        }
        return false
    }

    const createVariable = (isDependent: boolean) => {
        var newVariableId = 0
        var unnamedVariable = false
        props.variables.forEach(variable => {
            var id = variable.id
            if (id >= newVariableId) {
                newVariableId = id + 1
            }
            if (variable.name == "" || variable.name == undefined) {
                unnamedVariable = true
            }
        })
        if (!unnamedVariable) {
            var newVariables = cloneDeep(props.variables)
            newVariables = newVariables.concat({ "id": newVariableId, "name": "", "rs": [], "es": [], "isDependent": isDependent })
            // Add a range to independent variables
            if (!isDependent) {
                var newRangeId = 0
                newVariables.forEach(variable => {
                    variable.rs.forEach(range => {
                        var id = range.id
                        if (id >= newRangeId) {
                            newRangeId = id + 1
                        }
                    })
                })
                var variableIndex = newVariables.findIndex(v => v.id == newVariableId)
                newVariables[variableIndex].rs.push({ "id": newRangeId, min: 1, max: 1, inc: 1 })
                setSelectedVariableId(newVariableId)
            }
            else {
                setSelectedDependentVariableId(newVariableId)
            }
            props.setVariables(newVariables)
        }
    }

    const deleteVariable = () => {
        if (selectedVariableId != undefined) {
            var updatedVariables = cloneDeep(props.variables)
            var deleteIndex = updatedVariables.findIndex(v => v.id == selectedVariableId)
            updatedVariables.splice(deleteIndex, 1)
            props.setVariables(updatedVariables)
            setSelectedVariableId(undefined)
        }
    }

    const deleteDependentVariable = () => {
        if (selectedDependentVariableId != undefined) {
            var updatedVariables = cloneDeep(props.variables)
            var deleteIndex = updatedVariables.findIndex(v => v.id == selectedDependentVariableId)
            updatedVariables.splice(deleteIndex, 1)
            props.setVariables(updatedVariables)
            setSelectedDependentVariableId(undefined)
        }
    }

    const selectVariableRow = row => {
        setSelectedVariableId(parseInt(row.dataset.id))
    }

    const variableNameTab = (e) => {
        if (e.key === "Tab") {
            if (!variableNameBlur(e.currentTarget)) {
                createVariable(false)
            }
        }
    }

    return (
        <div className="variables">
            <div className="row">
                <div className="col">
                    <div className="row">
                        <b>
                            <label>
                                Independent Variables&emsp;
                                {!props.userIsOwner || props.limitedEditing ? "" :
                                    <>
                                        <a role="button" onClick={() => createVariable(false)}>
                                            <FontAwesomeIcon icon={faPlus} /> Add
                                        </a>
                                        &emsp;
                                        {selectedVariableId != undefined ?
                                            <a role="button" data-bs-toggle="modal" data-bs-target="#deleteVariableModal" >
                                                <FontAwesomeIcon icon={faMinus} /> Remove
                                            </a> : ""
                                        }
                                    </>}
                            </label>
                        </b>
                        <table className="table table-hover table-bordered table-light">
                            <thead>
                                <tr>
                                    <th scope="col">Name</th>
                                </tr>
                            </thead>
                            <tbody>
                                {props.variables.map((variable, index) => {
                                    if (!variable.isDependent) {
                                        return <tr onClick={e => selectVariableRow(e.currentTarget)} data-id={variable.id} key={variable.id} className={selectedVariableId == variable.id ? "table-active" : ""}>
                                            <td><input disabled={!props.userIsOwner || props.limitedEditing} className="form-control" data-index={index} type="text" onChange={e => variableNameChange(e.currentTarget)} onFocus={e => variableNameFocus(e.currentTarget)} onBlur={e => variableNameBlur(e.currentTarget)} value={props.variables[index].name}></input></td>
                                        </tr>
                                    }
                                })}
                            </tbody>
                        </table>
                    </div>
                    <RangeComponent
                        variables={props.variables}
                        setVariables={props.setVariables}
                        selectedVariableId={selectedVariableId}
                        previousValue={previousValue}
                        setPreviousValue={setPreviousValue}
                        userIsOwner={props.userIsOwner}
                        limitedEditing={props.limitedEditing}
                    />
                    <ExclusionComponent
                        variables={props.variables}
                        setVariables={props.setVariables}
                        selectedVariableId={selectedVariableId}
                        previousValue={previousValue}
                        setPreviousValue={setPreviousValue}
                        userIsOwner={props.userIsOwner}
                        limitedEditing={props.limitedEditing}
                    />
                    <div className="row">
                        <b>
                            <label>
                                Dependent Variables&emsp;
                                {!props.userIsOwner || props.limitedEditing ? "" :
                                    <>
                                        <a role="button" onClick={() => createVariable(true)}>
                                            <FontAwesomeIcon icon={faPlus} /> Add
                                        </a>
                                        &emsp;
                                        {selectedDependentVariableId != undefined ?
                                            <a role="button" data-bs-toggle="modal" data-bs-target="#deleteDependentVariableModal" >
                                                <FontAwesomeIcon icon={faMinus} /> Remove
                                            </a> : ""
                                        }
                                    </>}
                            </label>
                        </b>
                        <table className="table table-hover table-bordered table-light">
                            <thead>
                                <tr>
                                    <th scope="col">Name</th>
                                    <th scope="col">Calculation</th>
                                    <th scope="col">Precision</th>
                                </tr>
                            </thead>
                            <tbody>
                                {props.variables.map((variable, index) => {
                                    if (variable.isDependent) {
                                        return <tr onClick={() => setSelectedDependentVariableId(variable.id)} key={variable.id} className={selectedDependentVariableId == variable.id ? "table-active" : ""}>
                                            <td><input disabled={!props.userIsOwner || props.limitedEditing} className="form-control" data-index={index} type="text" onChange={e => variableNameChange(e.currentTarget)} onFocus={e => variableNameFocus(e.currentTarget)} onBlur={e => variableNameBlur(e.currentTarget)} value={props.variables[index].name}></input></td>
                                            <td><input disabled={!props.userIsOwner || props.limitedEditing} className="form-control" data-index={index} type="text" onChange={e => dependentVariableCalculationChange(e.currentTarget.value, index)} value={props.variables[index].calculation} /></td>
                                            <td><input disabled={!props.userIsOwner || props.limitedEditing} className="form-control" data-index={index} type="text" onChange={e => dependentVariablePrecisionChange(e.currentTarget.value, index)} value={props.variables[index].precision} /></td>
                                        </tr>
                                    }
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <DeleteConfirmationModalComponent
                itemId="deleteVariableModal"
                itemContent={"Do you want to delete variable " + (selectedVariableId == undefined || props.variables[props.variables.findIndex(v => v.id == selectedVariableId)].name) + "?"}
                deleteFunction={deleteVariable}
            />
            <DeleteConfirmationModalComponent
                itemId="deleteDependentVariableModal"
                itemContent={"Do you want to delete dependent variable " + (selectedDependentVariableId == undefined || props.variables[props.variables.findIndex(v => v.id == selectedDependentVariableId)].name) + "?"}
                deleteFunction={deleteDependentVariable}
            />
        </div>


    )
}



export default VariableComponent;

